import { Suspense } from 'react';
import Container from '../../components/Container';
import { ListSearch } from './components/list';
import { useRoot } from './hooks/useRoot';
import PageHeader from '@/components/PageHeader';
import { BackButton } from '@/components/ui/back-button';
import { useSearchingStore } from './store/useSearchStore';

export const Search = () => {
  useRoot();
  const { searchPage } = useSearchingStore();

  return (
    <>
      <PageHeader title={searchPage.searchPage?.title || 'Search'} backButton={<BackButton to="/" label="Back" />} />
      <Container className="mt-8">
        <div className="col-span-12">
          <ListSearch />
        </div>
      </Container>
    </>
  );
};
export const SearchScreen = () => {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-gray-900"></div>
        </div>
      }>
      <Search />
    </Suspense>
  );
};
